var review_select_category = $('#review-select-category');
if (review_select_category.length) {
    review_select_category.on('change', function (e) {
        selected_value = review_select_category[0].options[review_select_category[0].selectedIndex].value;
        if(selected_value == 1) {
            $('#chalets_form_gp').show();
            $('#activities_form_gp').hide();
        } else {
            $('#chalets_form_gp').hide();
            $('#activities_form_gp').show();
        }
    });
}